import type { ReactNode } from 'react';
import { useSessao } from '../autenticacao/ContextoDeSessao.js';
import { configuracao } from '../configuracao.js';

/** Cabeçalho, conteúdo e rodapé — a moldura comum de todas as telas autenticadas. */
export function Moldura({ children }: { children: ReactNode }) {
  const { operador, sair } = useSessao();

  return (
    <div className="envolucro">
      <header className="topo">
        <div>
          <div className="marca" style={{ fontSize: 18 }}>
            A PONTE <em>· COCKPIT DE VENDAS</em>
          </div>
          <div className="rotulo-caixa" style={{ marginTop: 7, letterSpacing: '.24em' }}>
            Turma Fundadora · 100 cadeiras · uso interno
          </div>
        </div>
        <div className="quem">
          <span>{operador?.nome || operador?.email}</span>
          <button className="bt vazado pequeno" onClick={sair}>
            Sair
          </button>
        </div>
      </header>

      {children}

      <footer className="rodape">
        <span>A Ponte · Comunidade Empresarial</span>
        <span>
          Split <b>70 Academia / 30 RREVELA</b> · gateway Asaas
        </span>
        <span>
          Operação <b>RREVELA</b> · {configuracao.ambiente} <b>{configuracao.versao}</b>
        </span>
      </footer>
    </div>
  );
}
